import {STATO_COMPLETO} from "../../../utility/common";
import React, {Fragment} from "react";
import {Link} from "react-router-dom";

export default function MenuVeicoli({
                                        user,
                                        isRuoloSocio,
                                        isRuoloCommissario,
                                        isRuoloPresidente,
                                        showMessage,
                                    }) {

    return (!isRuoloSocio() || (user && user.stato == STATO_COMPLETO)) && !isRuoloCommissario() && !isRuoloPresidente() ?
        <Fragment>
            <li className="nav-item">
                <Link className="nav-link" aria-current="page"
                      to="/list-veicoli">
                    <div data-bs-toggle="collapse"
                         data-bs-target=".navbar-collapse.show">
                        <i className="fas fa-car"/> Veicoli
                    </div>
                </Link>
            </li>
        </Fragment>
        :
        isRuoloSocio() && user && user.stato != STATO_COMPLETO &&
        <Fragment>
            <li className="nav-item">
                <button type={"button"} className="nav-link nav-link-btn"
                        aria-current="page"
                        onClick={() => {
                            showMessage("Veicoli", "In questa pagina potrai caricare i tuoi veicoli, non appena la tua richiesta di adesione verrà approvata.");
                        }}>
                    <div data-bs-toggle="collapse"
                         data-bs-target=".navbar-collapse.show">
                        <i className="fas fa-car"/> Veicoli
                    </div>
                </button>
            </li>
        </Fragment>
}